//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TabelaGenerica from '../../../../shared-components/generico/TabelaGenerica';

import { generateComputed } from '../../../../common/functions/roles-computed-generator';

export default {
  extends: TabelaGenerica,
  props: {
    isExportAvailable: {
      type: Boolean,
      default: true,
    },
    isSearchAvailable: {
      type: Boolean,
      default: true,
    },
    isPaginationAvailable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...generateComputed('Sellout', [
      'canImport',
      'canExport',
    ]),
    isContentAvailable() {
      return !!this.tableData && !!this.tableData.length;
    },
    filteredList() {
      return [];
    },
  },
  watch: {
    searchQuery() {
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        this.paginationPage = 0;
        this.filterDatasource();
      }, 500);
    },
  },
  methods: {
    filterDatasource() {
      this.showLoading = true;
      this.paginationPage = 1;

      const pagination = {
        size: this.paginationSize,
        page: this.paginationPage,
        filter: this.searchQuery,
      };

      this.$emit('TABELAGENERICA_BUSCAR_PROXIMA_PAGINA', pagination, this.closeLoading);
    },
    formatCurrency(val) {
      return (val || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    },
    formatDecimal(val) {
      return (val || 0).toLocaleString('pt-br', { style: 'decimal' });
    },
    formatPercent(val) {
      return (val || 0).toLocaleString('pt-br', { style: 'percent' });
    },
    detalharConsolidado(row) {
      this.$emit('SELLOUTTABELACONSOLIDADO_DETALHAR', row);
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/sell-out/SelloutTabelaConsolidado.vue?vue&type=script&lang=js&